export default {
  SET_USER(state, payload) {
    state.user = payload;
  },
};
